var _path, _rect, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThiNghiemAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9979 2.16738C18.9979 1.83601 18.7292 1.56738 18.3979 1.56738H15.753C15.4216 1.56738 15.153 1.83601 15.153 2.16738V7.55126C15.153 7.83399 14.9547 8.07621 14.682 8.15104C11.9247 8.90783 9.95117 10.9352 9.95117 13.3173C9.95117 16.3456 13.1408 18.8006 17.0754 18.8006C21.01 18.8006 24.1997 16.3456 24.1997 13.3173C24.1997 10.9352 22.2261 8.90784 19.4688 8.15105C19.1962 8.07622 18.9979 7.834 18.9979 7.55127V2.16738Z",
    fill: "#FFEA85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.4746,
    width: 5.20183,
    height: 1.56667,
    rx: 0.783333,
    fill: "#FFD946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.869 13.4033C22.5317 13.4033 23.0856 13.9548 22.8667 14.5804C22.8007 14.7688 22.7189 14.9542 22.6214 15.1353C22.3259 15.6844 21.8927 16.1834 21.3467 16.6036C20.8007 17.0239 20.1524 17.3573 19.439 17.5847C18.7255 17.8122 17.9609 17.9292 17.1887 17.9292C16.4165 17.9292 15.6518 17.8122 14.9384 17.5847C14.2249 17.3573 13.5767 17.0239 13.0307 16.6036C12.4846 16.1834 12.0515 15.6844 11.756 15.1353C11.6585 14.9542 11.5766 14.7688 11.5107 14.5804C11.2918 13.9548 11.8456 13.4033 12.5083 13.4033L21.869 13.4033Z",
    fill: "#FBA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1885 4.52564C17.1885 4.4295 17.2664 4.35156 17.3626 4.35156H18.9978V4.69971H17.3626C17.2664 4.69971 17.1885 4.62178 17.1885 4.52564V4.52564Z",
    fill: "#FFD946"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1885 5.57056C17.1885 5.47442 17.2664 5.39648 17.3626 5.39648H18.9978V5.74463H17.3626C17.2664 5.74463 17.1885 5.6667 17.1885 5.57056V5.57056Z",
    fill: "#FFD946"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1885 3.48169C17.1885 3.38555 17.2664 3.30762 17.3626 3.30762H18.9978V3.65577H17.3626C17.2664 3.65577 17.1885 3.57783 17.1885 3.48169V3.48169Z",
    fill: "#FFD946"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14199 5.82168C8.14199 5.49031 7.87337 5.22168 7.542 5.22168H5.12333C4.79196 5.22168 4.52333 5.49031 4.52333 5.82168V8.25294C4.52333 8.5327 4.32907 8.77286 4.06081 8.85224C1.68567 9.55507 0 11.3277 0 13.4033C0 16.0952 2.83523 18.2773 6.33266 18.2773C9.83009 18.2773 12.6653 16.0952 12.6653 13.4033C12.6653 11.3277 10.9797 9.55507 8.60451 8.85224C8.33625 8.77286 8.14199 8.5327 8.14199 8.25294V5.82168Z",
    fill: "#FFE1D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.07104,
    y: 3.83008,
    width: 4.52333,
    height: 1.39259,
    rx: 0.696296,
    fill: "#FFC0A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62243 2.94842C4.57021 2.58669 4.85079 2.2627 5.21627 2.2627H7.44927C7.81475 2.2627 8.09533 2.58669 8.04311 2.94842L7.91594 3.82936H4.7496L4.62243 2.94842Z",
    fill: "#E2003C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1084 13.4033C10.7711 13.4033 11.3258 13.9578 11.0854 14.5754C11.038 14.6972 10.9832 14.8174 10.921 14.9355C10.6653 15.4212 10.2904 15.8626 9.81789 16.2344C9.34536 16.6061 8.78438 16.9011 8.16698 17.1023C7.54959 17.3035 6.88787 17.407 6.21961 17.407C5.55134 17.407 4.88962 17.3035 4.27223 17.1023C3.65483 16.9011 3.09385 16.6061 2.62132 16.2344C2.14878 15.8626 1.77395 15.4212 1.51822 14.9355C1.45604 14.8174 1.4012 14.6972 1.3538 14.5754C1.11346 13.9578 1.66812 13.4033 2.33086 13.4033L10.1084 13.4033Z",
    fill: "#EE087B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33276 7.31079C6.33276 7.21465 6.4107 7.13672 6.50684 7.13672H8.1421V7.48487H6.50684C6.4107 7.48487 6.33276 7.40693 6.33276 7.31079V7.31079Z",
    fill: "#FFC0A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33276 6.26685C6.33276 6.17071 6.4107 6.09277 6.50684 6.09277H8.1421V6.44092H6.50684C6.4107 6.44092 6.33276 6.36299 6.33276 6.26685V6.26685Z",
    fill: "#FFC0A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThiNghiemAo);
export default __webpack_public_path__ + "static/media/thi_nghiem_ao.8d244ad5171a39694752656ea240445b.svg";
export { ForwardRef as ReactComponent };